import { Box, Button, Paper, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress, Alert, Snackbar } from "@mui/material";
import BackOfficeHeaderCompany from "../backoffice-filters/BackOfficeHeaderCompany";
import BackOfficeTabs from "./BackOfficeTabs";
import { RootState } from "../../store/store";
import { useSelector } from "react-redux";
import { useGetCompanyDescriptionQuery, usePutUpdateCompanyDescriptionMutation } from "../../store/api/backoffice/backofficeDetailApi";
import { useLocation } from "react-router-dom";
import { usePostCreateContactMutation, usePutUpdateContactMutation } from "../../store/api/backoffice/backofficeContactApi";
import { usePutUpdateCompanyAccessMutation } from "../../store/api/backoffice/backofficeApi";
import { filterContactById, filterContactWithoutId } from "../../utils/contact-filter";
import SideBarBackOffice from "../general/SideBarBackOffice";
import { useCallback } from "react";
import { useState } from "react";

function BackOfficeCompany() {
  const location = useLocation()
  const companyDetails = useSelector((state: RootState) => state.backofficeCompanyDetail)
  const companyContacts = useSelector((state: RootState) => state.backofficeCompanyContacts)
  const companyAccess = useSelector((state: RootState) => state.backofficeCompanyAccess)
  const { refetch  } = useGetCompanyDescriptionQuery(location.state.companyDatabaseId)  
  const [detailsUpdate] = usePutUpdateCompanyDescriptionMutation()
  const [createContact] = usePostCreateContactMutation()
  const [updateContacts] = usePutUpdateContactMutation()
  const [updateCompanyAccess] = usePutUpdateCompanyAccessMutation()
  const [openDialog, setOpenDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState<{ open: boolean; message: string; type: 'success' | 'error' }>({
    open: false,
    message: '',
    type: 'success'
  });

  const handleCloseAlert = () => {
    setAlert(prev => ({ ...prev, open: false }));
  };

  const handleSaveChanges = async () => {
    setIsLoading(true);
    try {
      let contactData = companyContacts.data
      let companyContactsWithId = filterContactById(contactData)
      let companyContactsWithoutId = filterContactWithoutId(contactData)
      
      await Promise.all([
        createContact({ companyDatabaseId: location.state.companyDatabaseId, companyContacts: companyContactsWithoutId }),
        updateContacts({ companyDatabaseId: location.state.companyDatabaseId, companyContacts: companyContactsWithId }),
        detailsUpdate({companyDatabaseId: location.state.companyDatabaseId, ...companyDetails.data})
      ]);

      if (companyAccess.data !== null && companyAccess.data !== undefined) {
        await updateCompanyAccess({companyDatabaseId: location.state.companyDatabaseId, ...companyAccess.data});
      }
      
      await refetch();
      setOpenDialog(false);
      setAlert({
        open: true,
        message: 'Alterações salvas com sucesso!',
        type: 'success'
      });
    } catch (error) {
      console.error('Erro ao salvar alterações:', error);
      setAlert({
        open: true,
        message: 'Erro ao salvar alterações. Por favor, tente novamente.',
        type: 'error'
      });
    } finally {
      setIsLoading(false);
    }
  }

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const EnableSaveChangesButton = useCallback(() => {
    if (companyDetails?.data?.companyName) {
      return true
    }
    return false
  }, [companyDetails?.data?.companyName]);

  return (
  <Box sx={{ display: 'flex' }}>
    <SideBarBackOffice />
    <Box sx={{ bgcolor: 'grey.100', height: '100%', width: '100%', paddingBlockStart: '68px' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column' }} >
        <BackOfficeHeaderCompany />
        <Box sx={{ display: 'flex', flexDirection: 'column', borderRadius: 1, bgcolor: 'common.white', marginInline: 1, marginBlockStart: 0.5, padding: 2 }}>
          <BackOfficeTabs />
        </Box> 
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', paddingBlockStart: 1, paddingBlockEnd: 2, marginBlockStart: 1, }}>
        <Paper elevation={2} sx={{position: 'fixed', bottom: '1.5rem', backgroundColor: 'transparent', boxShadow: 'none'}}>
          <Button variant='text' sx={{ margin: '0.5rem'}}>Fechar</Button>
          <Button onClick={handleSaveChanges} variant='contained' sx={{ margin: '0.5rem', boxShadow: '10px 12px 17px -7px rgba(0,0,0,0.75)' }}>
            Guardar Alterações
          </Button>
        </Paper>
      </Box>
    </Box>
  </Box>
  );
}

export default BackOfficeCompany;